/**
 * CSV «что на экране» — в браузере, без бэкенда (порт CRM
 * `components/report/export-csv.ts`). Формат под русский Excel: разделитель
 * «;», BOM UTF-8, десятичная запятая у чисел, переводы строк CRLF.
 */

export interface CsvColumn<R> {
  /** Заголовок колонки. */
  title: string;
  /** Значение ячейки. null/undefined — пусто. */
  value: (row: R) => string | number | boolean | null | undefined;
}

const NUMERIC = /^-?\d+(\.\d+)?$/;

function cell(v: string | number | boolean | null | undefined): string {
  if (v == null) return '';
  let s: string;
  if (typeof v === 'number') s = Number.isFinite(v) ? String(v).replace('.', ',') : '';
  else if (typeof v === 'boolean') s = v ? 'да' : 'нет';
  else s = NUMERIC.test(v) ? v.replace('.', ',') : v;
  // Защита от формул в Excel (=, +, -, @ в начале текста) — кроме чисел.
  if (/^[=+\-@]/.test(s) && !/^-?\d/.test(s)) s = `'${s}`;
  return /[";\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Собрать CSV-текст. */
export function toCsv<R>(columns: CsvColumn<R>[], rows: readonly R[]): string {
  const lines = [columns.map((c) => cell(c.title)).join(';')];
  for (const r of rows) lines.push(columns.map((c) => cell(c.value(r))).join(';'));
  return lines.join('\r\n');
}

/** Скачать файл из памяти. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** CSV таблицы на экране: exportCsv({ filename: 'Обучение 01.09–30.09', columns, rows }). */
export function exportCsv<R>({ filename, columns, rows }: { filename: string; columns: CsvColumn<R>[]; rows: readonly R[] }): void {
  const name = filename.toLowerCase().endsWith('.csv') ? filename : `${filename}.csv`;
  downloadBlob(new Blob(['﻿', toCsv(columns, rows)], { type: 'text/csv;charset=utf-8' }), name.replace(/[\\/:*?"<>|]+/g, '_'));
}
